import { Button, Container, TextField } from '@mui/material';
import { Box, styled } from '@mui/system';
import { useState } from 'react';
import Web3 from 'web3';
import { ReactComponent as MinusIcon } from '../../assets/icons/minus.svg';
import { ReactComponent as PlusIcon } from '../../assets/icons/plus.svg';
import logo from '../../assets/logo.png';
import mount from '../../assets/mount.png';
import ABI from '../Mint/abi.json';
import { SocialLinks } from '../SocialLinks/SocialLinks';
import './mint.css';



// Main Mint Component
export const Mint = () => {
  const [count, setCounter] = useState(1);

  // set counter via user
  const handleCounter = (e) => {
    if (
      e.inputType === 'deleteContentBackward' ||
      e.nativeEvent.inputType === 'deleteContentBackward' ||
      e.keyCode === 8 ||
      e.keyCode == 46
    ) {
      setCounter(0);
    }

    const value = e.target.value;
    const reg = new RegExp('^[0-9]+$');
    if (reg.test(value)) {
      if (Number(value) < 200) {
        setCounter(Number(e.target.value));
      } else {
        return;
      }
    }
  };

  const handleDecrement = () => {
    if (count > 1) {
      setCounter(Number(count) - 1);
    }
  };
  const handleIncrement = () => {
    if (count == 10) {
    }else{
      setCounter(Number(count) + 1);
    }
  };

  const handleMint = async (e) => {
    const abi = ABI;
  
    const web3 = new Web3(Web3.givenProvider);
    const contractAdress = '0x947dd75ad2bbd2ee53f3b07574763833e6018a14';
    const Contract = new web3.eth.Contract(abi, contractAdress);
  
    const accounts = await window.ethereum.enable();
    const account = accounts[0];
  
    const amount = web3.utils.toWei(String(count * 0.04), 'ether');
  
    try {
      const result = await Contract.methods
        .Mardymint(count, account)
        .send({
          from: account,
          gasLimit: '285000',
          value: amount,
        })
        .on('error', (error, receipt) => {
          alert('ERROR ' + error.message);
        })
        .on('receipt', function (receipt) {
          alert('Minted!');
        });
      //alert(result);
    } catch (error) {
      alert(error.message);
    }
  };


  console.log(count);
  return (
    <Root>
      <div className='cloud-content'>
        {[...Array(7)].map((cloud, index) => (
          <div key={index} className={`cloud-${index + 1} cloud-block`}>
            <div className='cloud'></div>
          </div>
        ))}
      </div>
      {/* <Clouds component='img' src={cloud} /> */}
      <Container>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '100vh',
            gap: '30px',
          }}
        >
          <Logo>
            <img component='img' src={logo} />
          </Logo>
          <BtnBox>
            <Box sx={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
              <IconButton onClick={handleDecrement}>
                <MinusIcon />
              </IconButton>
              <CountField
                sx={{ maxWidth: '130px' }}
                id='outlined-basic'
                variant='outlined'
                value={count}
                onChange={(e) => handleCounter(e)}
              />

              <IconButton onClick={handleIncrement}>
                <PlusIcon />
              </IconButton>
            </Box>
            <ConnectButton onClick={handleMint}>Mint</ConnectButton>
            <p style={{color:'white', textAlign:"center", fontSize:'18px',fontStyle:"bold", fontWeight:"bold"}}>On mobile? Connect to this website in your Metamask Web Browser. Learn how <a href="https://cryptofor.us/?cat=29">here</a></p>
            <p style={{color:'white', textAlign:"center", fontSize:'18px',fontStyle:"bold", fontWeight:"bold"}}>¿Usando un teléfono móvil? Escriba este mismo sitio web en su navegador de web dentro Metamask. Aprende cómo <a href="http://www.cryptoparanosotros.com/?cat=29"> aquí</a></p>
          </BtnBox>
        </Box>
      </Container>

      <SocialLinks />
    </Root>
  );
};


const Root = styled(Box)({
  background: `url(${mount})`,
  height: '100vh',
  width: '100%',
  backgroundSize: '100% 100%',
  position: 'relative',
  zIndex: 1,
  textAlign: 'center',
});
const Clouds = styled(Box)({
  position: 'absolute',
  left: '50%',
  top: 0,
  maxWidth: '50%',
  transform: 'translateX(-50%)',
  zIndex: -1,
});
const Logo = styled(Box)({
  display: 'flex',
  position: 'relative',
  zIndex: -1,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',

  '& img': {
    maxWidth: '35%',
  },
});
const BtnBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  flexDirection: 'column',
});
const ConnectButton = styled(Button)({
  color: 'white',
  background: '#000',
  padding: '15px 110px',
  fontSize: '22px',
  borderRadius: '15px',
  textShadow: '1px 1px 0px #09d709',
  '&:hover': {
    background: '#0009',
  },
});
const IconButton = styled(Button)({
  color: 'white',
  background: '#000',
  padding: '15px',
  fontSize: '22px',
  borderRadius: '15px',
  textShadow: '1px 1px 0px #09d709',
  '&:hover': {
    background: '#0009',
  },
});
const CountField = styled(TextField)({
  margin: 0,
  borderColor: '#fff',

  '.MuiInputBase-input': {
    color: '#fff',
  },
  '.MuiInputBase-root': {
    borderRadius: '15px !important',
    background: '#00000042',
  },
  '.MuiOutlinedInput': {
    borderRadius: '15px !important',
    background: '#00000042',
  },

  '.MuiInputBase-root': {
    border: '3px solid #000',
    borderRadius: '15px !important',
    background: '#00000042',
  },
  '.Mui-focused': {
    border: '3px solid #000',
  },
  '.MuiInputBase-input': {
    padding: '2.5px 0',
    textAlign: 'center',
    fontWeight: 800,
    fontSize: '30px',
    color: '#fff',
  },
  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#103a1e !important',
    border: 'none',
  },
});
